import { addDays, format, parseISO } from "date-fns";
import { de } from "date-fns/locale";
import type { Timestamp } from "firebase/firestore";
import type { Appointment, PlannerConfig } from "../types";

export function formatDate(value: string, pattern = "EEE, dd.MM.") {
  return format(parseISO(value), pattern, { locale: de });
}

export function formatTimestamp(value: Timestamp | null | undefined) {
  if (!value) return "gerade eben";
  return new Intl.DateTimeFormat("de-DE", {
    dateStyle: "short",
    timeStyle: "short"
  }).format(value.toDate());
}

export function weekdaysBetween(start: string, end: string) {
  const days: string[] = [];
  let cursor = parseISO(start);
  const last = parseISO(end);
  while (cursor <= last) {
    const weekday = cursor.getDay();
    if (weekday !== 0 && weekday !== 6) days.push(format(cursor, "yyyy-MM-dd"));
    cursor = addDays(cursor, 1);
  }
  return days;
}

export function timeToMinutes(value: string) {
  const [hours, minutes] = value.split(":").map(Number);
  return hours * 60 + minutes;
}

export function minutesToTime(value: number) {
  return `${String(Math.floor(value / 60)).padStart(2, "0")}:${String(value % 60).padStart(2, "0")}`;
}

export function slotsFor(config: PlannerConfig) {
  const slots: string[] = [];
  const start = timeToMinutes(config.dayStart);
  const end = timeToMinutes(config.dayEnd);
  for (let value = start; value + config.durationMinutes <= end; value += config.durationMinutes) {
    slots.push(minutesToTime(value));
  }
  return slots;
}

export function isSmsEligible(appointment: Appointment) {
  return appointment.notificationState !== "sending"
    && appointment.lastNotifiedScheduleVersion < appointment.scheduleVersion;
}

export function readableError(error: unknown): string {
  const message = error instanceof Error ? error.message : String(error);
  return message
    .replace(/^Firebase:\s*/i, "")
    .replace(/^FunctionsError:\s*/i, "")
    .replace(/\s*\(functions\/[\w-]+\)\.?$/i, "")
    .replace(/\[FirebaseError:\s*/i, "")
    .replace(/\]$/, "")
    || "Die Aktion konnte nicht abgeschlossen werden.";
}
